import { isNil } from 'rambda';
import { differenceInMinutes, isValid, parseJSON } from 'date-fns';

export const coerceDate = (date: Date | string) =>
  typeof date === 'string' ? parseJSON(date) : date;

export const differenceToHHMMSS = (segments: (number | undefined)[]) =>
  segments
    .map((num) => (!isNil(num) ? num.toString().padStart(2, '0') : '00'))
    .join(':');

export const calculateWaitingTime = (date: string | Date): string => {
  const coercedDate = coerceDate(date);

  if (!isValid(coercedDate)) return '';

  coercedDate.setSeconds(0);

  const now = new Date();
  const totalMinutes = Math.abs(differenceInMinutes(coercedDate, now));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  const days = Math.floor(hours / 24);

  if (hours < 24) {
    return differenceToHHMMSS([hours, minutes]);
  }

  if (days === 1) {
    return `${days} day ${differenceToHHMMSS([hours % 24])}h`;
  }

  if (days < 7) {
    return `${days} days`;
  }

  return `7+ days`;
};
